<template lang="pug">
  table#tbInventariosFisicos.table.is-striped.is-responsive.is-narrow
    thead
      tr
        th(colspan=3 align="center") Inventarios Fisicos
      tr
        th(align="center") Esfera
        th(align="center") T.M.
        th(align="center") %
    tbody
      tr
        td(align="center")
          span.tag.is-light.is-size-6.has-text-weight-medium  A
        td(align="center") 
          span.tag.is-light.is-size-6.has-text-weight-medium {{ getMasaEsfera('A', data) | numberFormatDecimal }}
        td(align="center")
          span.tag.is-light.is-size-6.has-text-weight-medium {{ getPorcEsfera('A', data) }}%
      tr
        td(align="center")
          span.tag.is-light.is-size-6.has-text-weight-medium  B
        td(align="center")
          span.tag.is-light.is-size-6.has-text-weight-medium  {{ getMasaEsfera('B', data) | numberFormatDecimal }}
        td(align="center")
          span.tag.is-light.is-size-6.has-text-weight-medium  {{ getPorcEsfera('B', data) }}%
      tr
        td(align="center")
          span.tag.is-black.is-size-6.has-text-weight-medium  TOTAL
        td(align="center")
          span.tag.is-black.is-size-6.has-text-weight-medium  {{ getMasaTotal(data) | numberFormatDecimal}}
        td(align="center")
          span.tag.is-black.is-size-6.has-text-weight-medium  {{ getPorcTotal(data) }}%
</template>

<script>
  import Decimal from 'decimal.js'
  export default {
    name: 'TbInventarioFisico',
    props: {
      data: {
        type: Array,
        default: [],
      },
    },
    methods: {
      getMasaEsfera(esfera,esferaData) {
        if (this.data.length > 0) {
          const masaA = new Decimal(esferaData[0].volTon)
          const masaB = new Decimal(esferaData[1].volTon)
          return esfera === 'A' ? masaA.toFixed(2) : masaB.toFixed(2)
        } else {
          return 0
        }
      },

      getPorcEsfera(esfera, esferaData) {
        if (this.data.length > 0) {
          const masaA = new Decimal(esferaData[0].volTon)
          const masaB = new Decimal(esferaData[1].volTon)
          const porcA = masaA.dividedBy(1950).times(100).toFixed(2)
          const porcB = masaB.dividedBy(1950).times(100).toFixed(2)
          return esfera === 'A' ? porcA : porcB
        } else {
          return 0
        }
      },
      
      getMasaTotal(esferas) {
        if (this.data.length > 0) {
          const masaA = new Decimal(esferas[0].volTon)
          const masaB = new Decimal(esferas[1].volTon)
          const total = masaA.plus(masaB).toFixed(2)
          return total
        } else {
          return 0
        }
      },
      getPorcTotal(esferas) {
        if (this.data.length > 0) {
          const masaA = new Decimal(esferas[0].volTon)
          const masaB = new Decimal(esferas[1].volTon)
          const porcA = masaA.dividedBy(1950)
          const porcB = masaB.dividedBy(1950)
          const total =  porcA.plus(porcB).dividedBy(2).times(100).toFixed(2)
          return total
        } else {
          return 0
        }
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/sca_Componentes/irge/dashboard/componentes/Tb_InventariosFisicos.vue